<div class="oa-sheet confirm-date-dialog">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            {{ texts.title }} #{{ proposal?.proposalNumber }}
            <span class="oa-sheet__subtitle">{{ proposal?.shortDescription }} · {{ proposal?.client?.name }} · {{ value }}</span>
        </h2>
        <button type="button" class="oa-icon-btn" mat-dialog-close aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body confirm-date-dialog__body">
        <mat-form-field appearance="outline" class="confirm-date-dialog__field">
            <mat-label>{{ texts.field }}</mat-label>
            <input matInput required [matDatepicker]="picker" [(ngModel)]="date" [max]="today" readonly
                (click)="picker.open()" aria-required="true">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <span class="confirm-date-dialog__hint">{{ texts.hint }}</span>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" mat-dialog-close>Cancelar</button>
        <button type="button" class="oa-btn oa-btn--primary" [disabled]="!date" (click)="confirm()">
            <mat-icon>{{ texts.icon }}</mat-icon>
            <span class="oa-btn__label">{{ texts.button }}</span>
        </button>
    </footer>
</div>
